var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-card"},[_c('div',{staticClass:"content"},[(_vm.delay == 1)?_c('StockChart',{attrs:{"chart":_vm.optionChart}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }